'use client';

import { useMemo } from 'react';

/**
 * Permission groups whose feature is no longer reachable from the app, so
 * their permissions have nothing left to gate and only add noise to the
 * Roles UI. They stay seeded on the backend, and roles that already hold
 * them keep them — hidden here, never stripped on save.
 *
 * - `clients` — Enterprise Clients (OMA-591) lost its sidebar and Cmd+K
 *   entry. The route survives for deep links and the API is still read by
 *   Reception, QR Review and the dashboard, but nobody should be granting
 *   the group from the Roles UI, and with no nav item it had no category to
 *   sit under either.
 */
const HIDDEN_PERMISSION_GROUPS = ['clients'] as const;

/**
 * Returns the set of permission groups that should be hidden from the
 * Roles UI right now. Add a group key to {@link HIDDEN_PERMISSION_GROUPS}
 * for a retired or feature-flagged permission group that should stay
 * seeded (so existing role grants aren't stripped) but not shown.
 */
export function useHiddenPermissionGroups(): ReadonlySet<string> {
  return useMemo(() => new Set<string>(HIDDEN_PERMISSION_GROUPS), []);
}
